const RESUME_FILE_CONFIG = {
  allowedTypes: [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
  maxFileSize: 64 * 1024 * 1024, // 64MB
  acceptedExtensions: [".pdf", ".docx"],
};

export default RESUME_FILE_CONFIG;
